import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RequestStatus } from "../../utils/Enums";
import { apiClient } from "../../utils/ApiClient";

interface LockedRecommendationsState {
    data: any[];
    getLockedRecommendationsStatus: RequestStatus;
    createRouteStatus: RequestStatus;
    bulkUpdateStatus: RequestStatus;
    errors: string[];
}

const initialState: LockedRecommendationsState = {
    data: [],
    getLockedRecommendationsStatus: RequestStatus.Idle,
    createRouteStatus: RequestStatus.Idle,
    bulkUpdateStatus: RequestStatus.Idle,
    errors: [],
};

export const getLockedRecommendations = createAsyncThunk(
    'lockedRecommendations/getLockedRecommendations',
    async (_, { rejectWithValue }) => {
        const response = await apiClient.get('recommendation-comments/locked');
        return response.data.data;
    }
);

export const createRecommendationRoute = createAsyncThunk(
    'lockedRecommendations/createRecommendationRoute',
    async (data: any, { rejectWithValue }) => {
        const response = await apiClient.post('recommendation-comments/create-route', data);
        return response.data;
    }
);

export const bulkUpdateRecommendationRoutes = createAsyncThunk(
    'lockedRecommendations/bulkUpdateRecommendationRoutes',
    async (data: any, { rejectWithValue }) => {
        const response = await apiClient.put('recommendation-comments/bulk-update', data);
        return response.data;
    }
);

const lockedRecommendationsSlice = createSlice({
    name: 'lockedRecommendations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getLockedRecommendations.pending, (state) => {
                state.getLockedRecommendationsStatus = RequestStatus.Loading;
            })
            .addCase(getLockedRecommendations.fulfilled, (state, action) => {
                state.getLockedRecommendationsStatus = RequestStatus.Success;
                state.data = action.payload;
            })
            .addCase(getLockedRecommendations.rejected, (state, action) => {
                state.getLockedRecommendationsStatus = RequestStatus.Failed;
                const errors = JSON.parse(action?.error?.message ?? '{}');
                if (errors) {
                    state.errors = Array.isArray(errors.errors) ? errors.errors : [];
                } else {
                    state.errors = ['Tuvastamata viga.'];
                }
            })
            .addCase(createRecommendationRoute.pending, (state) => {
                state.createRouteStatus = RequestStatus.Loading;
            })
            .addCase(createRecommendationRoute.fulfilled, (state) => {
                state.createRouteStatus = RequestStatus.Success;
            })
            .addCase(createRecommendationRoute.rejected, (state, action) => {
                state.createRouteStatus = RequestStatus.Failed;
            })

            .addCase(bulkUpdateRecommendationRoutes.pending, (state) => {
                state.bulkUpdateStatus = RequestStatus.Loading;
            })
            .addCase(bulkUpdateRecommendationRoutes.fulfilled, (state) => {
                state.bulkUpdateStatus = RequestStatus.Success;
            })
            .addCase(bulkUpdateRecommendationRoutes.rejected, (state, action) => {
                state.bulkUpdateStatus = RequestStatus.Failed;
            });
    },
});

export default lockedRecommendationsSlice.reducer;